import axios from 'axios';
import React, { Component } from 'react';
import * as util from '../../../utils/EnumMapping';
import { TableContainer } from '../../common/table/TableContainer';
import * as columns from './BankColumns';
import { handlePost } from '../../../utils/AxiosUtil';
import { withSnackbar } from 'notistack';
import { getMessage } from '../../../utils/ErrorMessageTranslate';
import { TableLoadingIndicator } from '../../common/table/TableLoadingIndicator';

class Bank extends Component {
    state = {
        transactions: [],
        selectedFile: null,
        isLoading: true,
    };

    componentDidMount() {
        this.loadData();
    }

    refreshState() {
        console.log("refresh");
        this.loadData();
    }

    loadData = async () => {
        this.setState({ isLoading: true });

        try {
            const response = await this.callApi();
            this.enrich(response.data);
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "BANK";
            item.transactionTypeLabel = util.getLabel(util.transactionTypes, item.transactionType);
            item.simpleTransactionTypeLabel = util.getLabel(util.simpleTransactionTypes, item.simpleTransactionType);
            item.transactionSideLabel = util.getLabel(util.transactionSides, item.transactionSide);
            item.stateLabel = util.getLabel(util.transactionStates, item.state);
            return item;
        })
        this.setState({ transactions: data })
    }

    callApi = async () => {
        const response = await axios.get('/api/bank');
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    onChangeHandler = event => {
        this.setState({ selectedFile: event.target.files[0] })
    }

    onClickHandler = (event) => {
        console.log(event.target.files[0]);
        if (event.target.files[0]) {
            const data = new FormData();
            data.append('file', event.target.files[0]);
            const path = '/api/bank-upload';
            handlePost(path, data, this);
        }
    }

    handleSuccess = (res) => {
        if (res.data) {
            console.log(res.data);
            /* eslint-disable array-callback-return */
            res.data.map(e => {
                this.props.enqueueSnackbar(e.params[0] + getMessage(e), { variant: e.severity.toLowerCase(), persist: true });
            })
        }
        this.loadData();
    }

    triggerMatcher = (event) => {
        console.log("triggerMatcher");
        console.log(event);
        axios.get('/api/matcher');
    }

    render() {
        return (
            <div className="Bank">
                <section id="main-content">
                    {this.state.isLoading ? (
                        <div className="content">
                            <TableLoadingIndicator />
                        </div>
                    ) : (
                        <TableContainer columns={columns.columns(() => this.refreshState())}
                            data={this.state.transactions}
                            needGlobalfilter={true}
                            tableName="Bank"
                            csvOnChangeHandler={this.onChangeHandler}
                            csvOnClickHandler={this.onClickHandler}
                            triggerMatcher={this.triggerMatcher}
                        />
                    )}
                </section>
            </div>
        );
    }
}

export default withSnackbar(Bank);
